import { useEffect, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { L, useT } from '../i18n/locale.jsx'
import { getConsent, setConsent } from '../consent'

// Banner GDPR (decline-by-default). Apare doar pentru utilizatorii nehotărâți, după mount
// (deci NU se „bake" în HTML-ul prerendat și nu pâlpâie pentru cei care au decis deja).
export default function ConsentBanner() {
  const t = useT().consent
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (typeof navigator !== 'undefined' && navigator.webdriver) return // prerender
    if (getConsent() === null) setShow(true)
  }, [])

  const decide = (value) => {
    setConsent(value)
    setShow(false)
  }

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 24, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 24, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
          role="dialog"
          aria-label="Cookie consent"
          className="fixed inset-x-3 bottom-3 z-[60] mx-auto max-w-site rounded-2xl border border-forest-line bg-forest-deep/95 p-5 text-cream shadow-2xl backdrop-blur md:inset-x-auto md:right-6 md:bottom-6 md:max-w-md md:p-6"
        >
          <p className="text-[13px] leading-relaxed text-cream-soft">
            {t.message}{' '}
            <L to="/privacy" className="text-honey underline underline-offset-2 transition-colors hover:text-honey-soft">
              {t.privacy}
            </L>
          </p>
          <div className="mt-4 flex items-center gap-3">
            <button
              type="button"
              onClick={() => decide('granted')}
              className="inline-flex min-h-[44px] items-center rounded-full bg-honey px-5 font-mono text-[11px] uppercase tracking-[0.1em] text-ink transition-colors duration-300 ease-quint hover:bg-honey-soft"
            >
              {t.accept}
            </button>
            <button
              type="button"
              onClick={() => decide('denied')}
              className="inline-flex min-h-[44px] items-center rounded-full border border-cream/25 px-5 font-mono text-[11px] uppercase tracking-[0.1em] text-cream transition-colors duration-300 ease-quint hover:border-cream/50"
            >
              {t.decline}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
